"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  olapicDefaultTranslations: true,
  olapicTranslationsNamespace: true,
  OlapicFeature: true
};
Object.defineProperty(exports, "OlapicFeature", {
  enumerable: true,
  get: function () {
    return _constants.OlapicFeature;
  }
});
Object.defineProperty(exports, "olapicDefaultTranslations", {
  enumerable: true,
  get: function () {
    return _defaultTranslations.defaultTranslations;
  }
});
Object.defineProperty(exports, "olapicTranslationsNamespace", {
  enumerable: true,
  get: function () {
    return _defaultTranslations.translationsNamespace;
  }
});
var _enums = require("./models/olapic/enums");
Object.keys(_enums).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _enums[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _enums[key];
    }
  });
});
var _olapicWidget = require("./olapicWidget");
Object.keys(_olapicWidget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _olapicWidget[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _olapicWidget[key];
    }
  });
});
var _WidgetSkeleton = require("./components/WidgetSkeleton");
Object.keys(_WidgetSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _WidgetSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WidgetSkeleton[key];
    }
  });
});
var _WidgetSkeletonWrapper = require("./containers/WidgetSkeletonWrapper");
Object.keys(_WidgetSkeletonWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _WidgetSkeletonWrapper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WidgetSkeletonWrapper[key];
    }
  });
});
var _defaultTranslations = require("./constants/defaultTranslations");
var _constants = require("./constants");
